import React, { FC, useEffect, useState } from 'react';
import { ArrowBack } from '@mediahuis/chameleon-theme-wl/icons';
import { Logo, Paper, Icon, Stack, Caption, Heading, Paragraph } from '@mediahuis/chameleon-react';
import { BRAND_LOGO_TYPE } from '../../types/general';
import { ERROR_CODES } from '../../types/error';
import { useTranslation } from 'react-i18next';
import { useBrandLogo } from '../../hooks/useBrandLogo';
import { useBrandGroupConfig } from '../../hooks/useBrandGroupConfig';

import './error.css';
import { useQueryParams } from '../../hooks/useQueryParams';

export const ErrorFallBack: FC<{ error: Error }> = ({ error }) => {
  const { t } = useTranslation();
  const brandLogoHook = useBrandLogo();
  const brandGroupConfigHook = useBrandGroupConfig();
  const { brand } = useQueryParams();
  const defaultBrandConfig = brandGroupConfigHook.getBrandConfigFromBrandId(brand);

  const [errorStatus, setErrorStatus] = useState<number>(ERROR_CODES.INTERNAL_ERROR);

  useEffect(() => {
    if (error?.message === ERROR_CODES.NOT_FOUND.toString()) setErrorStatus(ERROR_CODES.NOT_FOUND);
  }, [error]);

  return (
    <Stack className="error__content m-auto" alignItems="center" flexDirection="column">
      {defaultBrandConfig && (
        <Stack
          className="error__content__header text-center my-3"
          justifyContent="space-between"
          flexDirection="row"
          alignItems="center">
          <a
            className="error__content__link text-center"
            href={`https://${defaultBrandConfig.urlDisplay}`}>
            <Caption className="error__content__text--light" size="lg" as="div">
              <Icon as={ArrowBack} color="colorTertiary60" />
              {t('register.error.backTo')}{' '}
              <span className="link--bold">{defaultBrandConfig.name}</span>
            </Caption>
          </a>
          <Logo width="85px" />
        </Stack>
      )}
      <Stack alignItems="center" flexDirection="column">
        <Paper className="error__content__paper">
          <Stack alignItems="center" flexDirection="column" className="m-auto">
            <Stack className="mb-8">
              {brandLogoHook(BRAND_LOGO_TYPE.DEFAULT) && (
                <img
                  alt="logo"
                  src={brandLogoHook(BRAND_LOGO_TYPE.DEFAULT)}
                  width="75%"
                  style={{ margin: 'auto' }}
                />
              )}
              {!brandLogoHook(BRAND_LOGO_TYPE.DEFAULT) && (
                <Logo width="75%" style={{ margin: 'auto' }} />
              )}
            </Stack>
            <Heading
              className="error__content__text--dark text-center mb-3"
              fontWeight="bold"
              size="sm"
              as="div">
              {errorStatus === ERROR_CODES.NOT_FOUND && t('register.error.pageNotFound')}
              {errorStatus === ERROR_CODES.INTERNAL_ERROR && t('register.error.somethingWentWrong')}
            </Heading>
            {errorStatus === ERROR_CODES.INTERNAL_ERROR && (
              <Paragraph className="error__content__text--light text-center mb-6" as="div">
                {t('register.error.tryAgain')}
              </Paragraph>
            )}
            <Paragraph className="error__content__text--light text-center mt-0" as="div">
              {errorStatus === ERROR_CODES.NOT_FOUND && t('register.error.pageCannotBeFound')}
              {errorStatus === ERROR_CODES.INTERNAL_ERROR &&
                t('register.error.contactCustomerService')}
            </Paragraph>
          </Stack>
        </Paper>
      </Stack>
    </Stack>
  );
};
